/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { JobTypeFromJSON, JobTypeToJSON, } from './';
export function TradeFromJSON(json) {
    return TradeFromJSONTyped(json, false);
}
export function TradeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'tradeId': !exists(json, 'tradeId') ? undefined : json['tradeId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'tradeName': !exists(json, 'tradeName') ? undefined : json['tradeName'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
        'creationTimestamp': !exists(json, 'creationTimestamp') ? undefined : (json['creationTimestamp'] === null ? null : new Date(json['creationTimestamp'])),
        'modificationTimestamp': !exists(json, 'modificationTimestamp') ? undefined : (json['modificationTimestamp'] === null ? null : new Date(json['modificationTimestamp'])),
        'jobTypes': !exists(json, 'jobTypes') ? undefined : (json['jobTypes'] === null ? null : json['jobTypes'].map(JobTypeFromJSON)),
    };
}
export function TradeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'tradeId': value.tradeId,
        'propertyId': value.propertyId,
        'tradeName': value.tradeName,
        'createdBy': value.createdBy,
        'modifiedBy': value.modifiedBy,
        'creationTimestamp': value.creationTimestamp === undefined ? undefined : (value.creationTimestamp === null ? null : value.creationTimestamp.toISOString()),
        'modificationTimestamp': value.modificationTimestamp === undefined ? undefined : (value.modificationTimestamp === null ? null : value.modificationTimestamp.toISOString()),
        'jobTypes': value.jobTypes === undefined ? undefined : (value.jobTypes === null ? null : value.jobTypes.map(JobTypeToJSON)),
    };
}
